<template>
<nav>
    <div class="container flex">

        <router-link :to="{name: 'home'}" class="logo" @click.native="handleLinkClick">
            <img src="../assets/logo.png" alt="Forever technologies company logo">
            <span> BUILDING ETERNAL DESIGNS </span>
        </router-link>

        <ul class="flex nav-links" :class="{'opened' : menuOpened, 'menu-close': isMenuClosing}">
            <li>
                <router-link :to="{name: 'home'}" class="flex" @click.native="handleLinkClick">Home</router-link>
            </li>
            <li class="dropdown">
                <span class="flex" @click="handleDropdownClick">
                    Services
                </span>
                <div class="dropdown-box">
                    <router-link :to="{name: 'rebarDetailing'}" @click.native="handleLinkClick" >
                        Rebar Detailing
                    </router-link>
                    <router-link :to="{name: 'rebarEstimation'}" @click.native="handleLinkClick">
                        Rebar Estimation
                    </router-link>
                    <router-link :to="{name: 'structuralDesign'}" @click.native="handleLinkClick" >
                        Structural Design
                    </router-link>
                    <router-link :to="{name: 'precastDesignDetailing'}" @click.native="handleLinkClick" >
                        Precast Design and Detailing
                    </router-link>
                    <router-link :to="{name: 'softwareDevelopment'}" @click.native="handleLinkClick" >
                        Software Development
                    </router-link>
                </div>
            </li>
            <li>
                <router-link :to="{name: 'qualityandvalue'}" class="flex" @click.native="handleLinkClick">Quality & Value</router-link>
            </li>
            <li class="dropdown">
                <span class="flex" @click="handleDropdownClick">Projects</span>
                <div class="dropdown-box">
                    <router-link :to="{name: 'rebarProject'}" @click.native="handleLinkClick"
                    >Rebar Detailing</router-link>
                    <router-link :to="{name: 'structuralDesignProject'}" @click.native="handleLinkClick"
                    >Structural Design</router-link>
                    <router-link :to="{name: 'softwareDevelopmentProject'}" @click.native="handleLinkClick"
                    >Software Development</router-link>
                </div>
            </li>
            <li>
                <router-link :to="{name: 'careers'}" class="flex" @click.native="handleLinkClick">Careers</router-link>
            </li>
            <li>
                <router-link :to="{name: 'contactus'}" class="flex" @click.native="handleLinkClick">Contact us</router-link>
            </li>

            <li class="social-links flex">
                <a href="#" class="flex" @click="handleLinkClick">
                    <img src="../assets/facebook.png" alt="facebook" />
                </a>
                <a href="#" class="flex" @click="handleLinkClick">
                    <img src="../assets/twitter.png" alt="facebook" />
                </a>
                <a href="#" class="flex" @click="handleLinkClick">
                    <img src="../assets/linkedin.png" alt="facebook" />
                </a>
            </li>
        </ul>

        <button
            class="hamburger hamburger--spin btn" :class="{'is-active' : menuOpened}"
            @click="handleHamburgerClick"
            ref="hamburger"
        >
            <span class="hamburger-box">
                <span class="hamburger-inner"></span>
            </span>
        </button>
    </div>
</nav>
</template>

<script>
import $ from 'jquery';

export default {
    data() {
        return {
            menuOpened: false,
            isMenuClosing: false,
            hovered: false
        }
    },
    methods: {
        handleHamburgerClick() {
            if( this.menuOpened )
            {
                this.isMenuClosing = true;
                setTimeout( () => {
                    this.menuOpened = false;
                    this.isMenuClosing = false;
                    $('html').removeClass('no-scroll');
                }, 500);
                $('.dropdown').removeClass('showing');
            }
            else
            {
                this.menuOpened = true;
                $('html').addClass('no-scroll');
            }
        },
        handleLinkClick(){
            if( this.menuOpened )
                this.$refs.hamburger.click();
        },
        handleDropdownClick( event ) {
            if( this.menuOpened )
                $( event.target.parentElement ).toggleClass('showing');
        }
    },
}
</script>

<style scoped>

nav
{
    width: 100%;
    position: fixed;
    z-index: 5;
    top: 0; left: 0;
    background-color: #fff;
    box-shadow: 0px 0px 9px rgb(0, 0, 0, 0.2);
}

.container
{
    max-width: 1440px;
    align-items: center;
}

.logo, .logo img { width: 280px; }

.logo span
{
    font-family: 'Raleway', sans-serif;
    font-size: 12px;
    font-weight: 600;
    color: #1F2181;
    display: block;
    text-align: center;
    margin-top: 3px;
    text-shadow: 0px 0px 3px rgb(0, 0, 0,0.3);
}

.nav-links
{
    width: calc(100% - 250px);
    justify-content: center;
}

.nav-links li
{
    display: flex;
    align-items: center;
    height: 80px;
}

.nav-links li:first-child { margin-left: auto; }

.nav-links a, .nav-links span
{
    font-family: 'Montserrat', sans-serif;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 600;
    color: #666;
    padding: 0px 15px;
    outline: none;
    cursor: pointer;
}

.nav-links a:hover, .nav-links a:focus,
.nav-links a.router-link-exact-active,
.nav-links span:hover,
.nav-links span.router-link-exact-active
{ color: #00C7FF; }

.hamburger { display: none; }

.dropdown { position: relative; }

.dropdown-box
{
    display: none;
    position: absolute;
    z-index: 2;
    background-color: #000;
    width: max-content;
    top: calc(100% - 12px); left: 16px;
    border-radius: 5px;
    padding: 15px 20px;
    box-shadow: 0px 0px 3px rgb(255, 255, 255, 0.5) ;
}

.dropdown:hover .dropdown-box { display: block; }

.dropdown-box>a
{
    display: block;
    height: auto;
    padding: 15px 0;
    color: #fff;
}

.social-links { margin-left: auto; }

.social-links a { width: 40px; justify-content: center; }

.social-links img
{
    height: 25px;
    filter: drop-shadow(0px 0px 3px rgb(0, 0, 0, 0.25));
    transition: all 0.3s ease;
}

.social-links img:hover
{
    transform: scale(1.1,1.1);
}

@media only screen and  (max-width: 1023px)
{
    .hamburger
    {
        margin-left: auto;
        height: 80px; width: 35px;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: opacity 0.15s linear, filter 0.15s linear;
        background-color: #fff;
    }

    .hamburger-box
    {
        width: 35px;
        height: 24px;
        display: inline-block;
        position: relative;
    }

    .hamburger-inner
    {
        display: block;
        top: 50%;
        margin-top: -2px;
        background-color: #030081;
        color: #030081;
    }

    .hamburger-inner, .hamburger-inner::before, .hamburger-inner::after
    {
        width: 25px;
        height: 4px;
        border-radius: 4px;
        position: absolute;
        transition: transform 0.15s ease;
    }

    .hamburger-inner::before, .hamburger-inner::after
    {
        content: "";
        width: 35px;
        display: block;
        background-color: currentColor;
    }

    .hamburger.is-active .hamburger-inner { width: 35px; }

    .hamburger-inner::before { top: -10px; }

    .hamburger-inner::after { bottom: -10px; }

    .hamburger--spin .hamburger-inner
    {
        transition-duration: 0.22s;
        transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }

    .hamburger--spin .hamburger-inner::before
    { transition: top 0.1s 0.25s ease-in, opacity 0.1s ease-in; }

    .hamburger--spin .hamburger-inner::after
    {
        transition: bottom 0.1s 0.25s ease-in,
                transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }

    .hamburger--spin.is-active .hamburger-inner
    {
        transform: rotate(225deg);
        transition-delay: 0.12s;
        transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    .hamburger--spin.is-active .hamburger-inner::before
    {
        top: 0;
        opacity: 0;
        transition: top 0.1s ease-out, opacity 0.1s 0.12s ease-out;
    }

    .hamburger--spin.is-active .hamburger-inner::after
    {
        bottom: 0;
        transform: rotate(-90deg);
        transition: bottom 0.1s ease-out, transform 0.22s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    .nav-links { display: none; }

    .nav-links.opened
    {
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        height: calc(100vh - 80px); width: 100vw;
        background-color: #000;
        position: absolute;
        top: 80px; left: 0;
        z-index: 3;
        overflow: hidden;
        border-bottom: 3px solid rgb(0, 0, 0,0.5);
        box-shadow: inset 0px 0px 12px rgb(0, 0, 0,0.15);
        animation: menu-open-anm 0.5s ease;
        overflow-y: scroll;
    }

    .nav-links.opened li { height: auto; display: block; }

    .nav-links.opened a, .nav-links.opened span, .nav-links.opened .social-links
    {
        width: 100vw; height: 60px;
        font-size: 14px;
        margin: 0;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        padding: 23px 12px;
        color: #fff !important;
        border-bottom: 1.5px solid rgb(255, 255, 255,0.8);
    }

    .dropdown
    {
        border-bottom: 1.5px solid rgb(255, 255, 255,0.8);
        position: relative;

        max-width: 100vw;
    }

    .dropdown::after
    {
        content: '';
        position: absolute;
        top: 25px;
        right: 15px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 7px 5px 0 5px;
        border-color: whitesmoke transparent transparent transparent;
    }

    .dropdown.showing::after
    {
        transform: rotate(180deg);
    }

    .nav-links.opened span { border-bottom: 0; }

    .nav-links.opened .dropdown-box
    {
        display: none;
        box-shadow: none;
        position: static;
        padding: 0 0 0 20px;
        background-color: transparent;
    }

    .nav-links.opened .dropdown.showing .dropdown-box { display: block; }

    .nav-links.opened .dropdown-box a
    {
        border: 0;
        border-bottom: 1px solid rgb(255, 255, 255,0.8);
        height: 50px;
        padding: 16px 12px;
        display: block;
    }

    .dropdown-box a:last-child { border: 0; }

    .nav-links.opened .social-links
    {
        border-bottom-width: 0;
        justify-content: center;
    }

    .nav-links.opened .social-links a
    {
        width: fit-content;
        border-bottom-width: 0;
    }

    .nav-links.opened.menu-close { animation: menu-close-anm 0.5s ease; }

    @keyframes menu-open-anm
    {
        from { height: 0px; }

        to { height: calc(100vh - 80px); }
    }

    @keyframes menu-close-anm
    {
        0% { height: calc(100vh - 80px); }

        100% { height: 0px; }
    }
}

@media only screen and  (max-width: 767px)
{
    .logo, .logo img { width: 200px; }

    .logo span { font-size: 8px; }
}

</style>